import React, { Component } from 'react';
import classNames from 'classnames';
import { translate } from 'react-polyglot';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import u from 'updeep';
import isEqual from 'lodash/isEqual';
import OfflineThemeCard from '../OfflineThemeCard';
import OfflineGradeCard from '../OfflineGradeCard';
import DocumentClass from '../DocumentClass';
import BookCard from '../BookCard';
import Button from '../Button';
import CollapsibleSection from '../CollapsibleSection';
import { gaEventCategories, gaEventLabel, gaEventActions, themeArray , links , gaReadSource, offlineBookUrls, siteLocale} from '../../lib/constants';
import { isRtlLanguage } from '../../lib/appHelpers';
import SelectableGrid from '../SelectableGrid';
import Grid from '../Grid';
import SvgIcon from '../SvgIcon';
import Tabs from '../Tabs';
import Tab from '../Tab';

import './OfflineBooks.scss';
import OfflineStemCard from '../OfflineStemCard/OfflineStemCard';
import Modal from '../Modal';
import LoaderBlock from '../LoaderBlock';

@translate()
class OfflineBooks extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalVisible: {
        delete: false,
        help: false
      },
      URLBeforeGoingOffline: null
    }

    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.online, nextProps.online)) {
      if (!nextProps.online) {
        this.setState({ URLBeforeGoingOffline: window.location.pathname })
        return;
      } 
      if (nextProps.online && this.state.URLBeforeGoingOffline !== links.offlineBooks() && !offlineBookUrls.includes(this.state.URLBeforeGoingOffline) && !this.props.isOfflineTranslatorVisible) {
        window.location.href = links.home();
      }
    }
  }

  onOpenModal(modalName) {
    this.setState(u({
      isModalVisible: {
        [modalName]: true
      }
    }, this.state));
  }

  onCloseModal(modalName) {
    this.setState(u({
      isModalVisible: {
        [modalName]: false
      }
    }, this.state));
}
  onTabChange = (index) =>{
    const { 
      offline,
      onTriggerEvents
    } = this.props;
    let eventLabel;
    if (index === 0) {
      eventLabel = gaEventLabel.read
    }
    else if (index === 1) {
      eventLabel = gaEventLabel.readingProgram
    }
    else if (index === 2) {
      eventLabel = gaEventCategories.flpMerge
    }
    else if (index === 3) {
      eventLabel = gaEventCategories.stem
    }
    else {
      eventLabel = gaEventLabel.translate
    }

    onTriggerEvents({ gtmAction: `clicked_${eventLabel}`, gtmLabel: gaEventActions.menuUsage, d4: offline ? 'Offline' : 'Online'})
     this.props.onTabChangeUrl(index)
  }

  renderBookEls = (books, tabName) => {
    const { 
      online, 
      activeTabIndex,
      openOfflineTranslation,
      editActive 
    } = this.props;
    
    return books.map(book => {
      return (
        <BookCard
          key={book.id}
          id={book.id}
          book={book}
          shouldDisplayMenu={(activeTabIndex === 4) ? false : true} // hide menu for books in translate tab
          customMenu = {true}
          hideQuickViewBtn={true}
          shouldShowReadIcon={true}
          noSrcSet={!online}
          hideReadCountStat={true}
          readSource={gaReadSource.offlineLibrary}
          onClick={(!editActive && activeTabIndex === 4) ? openOfflineTranslation.bind(this, book) : null}
          isRtl={this.props.isRtl}
          eventLabel={tabName}
          eventCategory={gaReadSource.offlineLibrary}
        />
      );
    });
  }

  renderReadingProgramThemeEl(baseClassName, language, gradesClasses) {
    const {
      //t,
      online,
      editActive,
      viewport,
      onChangeCheckedThemeValues,
      themeCheckedValues,
      rpLanguageSelectedBooks
    } = this.props

    let newReaderBooks, earlyReaderBooks, middleReaderBooks, advancedReaderBooks = [];
    if(language === 'en'){
       newReaderBooks = rpLanguageSelectedBooks.filter(book => book.fluencyId === "1" && (book.locale === undefined || book.locale === language));
       earlyReaderBooks = rpLanguageSelectedBooks.filter(book => book.fluencyId === "2" && (book.locale === undefined || book.locale === language));
       middleReaderBooks = rpLanguageSelectedBooks.filter(book => book.fluencyId === "3" && (book.locale === undefined || book.locale === language));
       advancedReaderBooks = rpLanguageSelectedBooks.filter(book => book.fluencyId === "4" && (book.locale === undefined || book.locale === language));
    }
    else {
       newReaderBooks = rpLanguageSelectedBooks.filter(book => book.fluencyId === "1" && book.locale === language);
       earlyReaderBooks = rpLanguageSelectedBooks.filter(book => book.fluencyId === "2" && book.locale === language);
       middleReaderBooks = rpLanguageSelectedBooks.filter(book => book.fluencyId === "3" && book.locale === language);
       advancedReaderBooks = rpLanguageSelectedBooks.filter(book => book.fluencyId === "4" && book.locale === language);
    }

    const newReaderThemeArray = themeArray.map(themeNumber => newReaderBooks.filter(book => parseInt(book.themeNumber , 10) === themeNumber))
    const earlyReaderThemeArray = themeArray.map(themeNumber => earlyReaderBooks.filter(book => parseInt(book.themeNumber , 10) === themeNumber))
    const middleReaderThemeArray = themeArray.map(themeNumber => middleReaderBooks.filter(book => parseInt(book.themeNumber , 10) === themeNumber))
    const advancedReaderThemeArray = themeArray.map(themeNumber => advancedReaderBooks.filter(book => parseInt(book.themeNumber , 10) === themeNumber))
    
    const isRtl = isRtlLanguage(language);
    
    return (
      <div className={classNames(gradesClasses)}>
        {
          newReaderBooks.length > 0 && newReaderThemeArray.length > 0 && 
          <div >
            {
              newReaderThemeArray.map(themeBooks => {
                return <OfflineThemeCard themeBooks={themeBooks} online={online} editActive={editActive} onChange={onChangeCheckedThemeValues}
                  themeCheckedValues={themeCheckedValues} fluencyId={1} viewport={viewport} isRtl={isRtl} isRtlLocale={this.props.isRtl}/>
              })
            }
          </div>

        }
        {
          earlyReaderBooks.length > 0 &&
          <div>
            {
              earlyReaderThemeArray.map(themeBooks => {
                return <OfflineThemeCard themeBooks={themeBooks} online={online} editActive={editActive} onChange={onChangeCheckedThemeValues}
                  themeCheckedValues={themeCheckedValues} fluencyId={2} viewport={viewport} isRtl={isRtl} isRtlLocale={this.props.isRtl}/>
              })
            }
          </div>
        }
        {
          middleReaderBooks.length > 0 &&
          <div>
            {
              middleReaderThemeArray.map(themeBooks => {
                return <OfflineThemeCard themeBooks={themeBooks} online={online} editActive={editActive} onChange={onChangeCheckedThemeValues}
                  themeCheckedValues={themeCheckedValues} fluencyId={3} viewport={viewport} isRtl={isRtl} isRtlLocale={this.props.isRtl}/>
              })
            }
          </div>
        }
        {
          advancedReaderBooks.length > 0 &&
          <div>
            {
              advancedReaderThemeArray.map(themeBooks => {
                return <OfflineThemeCard themeBooks={themeBooks} online={online} editActive={editActive} onChange={onChangeCheckedThemeValues}
                  themeCheckedValues={themeCheckedValues} fluencyId={4} viewport={viewport} isRtl={isRtl} isRtlLocale={this.props.isRtl}/>
              })
            }
          </div>
        }
      </div>
    )
  }

  renderFlpHomeEl(baseClassName, language, gradesClasses) {
    const {
      // t,
      online,
      editActive,
      viewport,
      onChangeCheckedFlpValues,
      flpCheckedValues,
      flpHomeBooks,
    } = this.props

    let grade1Books, grade2Books, grade3Books = [];

    grade1Books = flpHomeBooks.filter(book => book.fluencyId === 1 && book.locale === language);
    grade2Books = flpHomeBooks.filter(book => book.fluencyId === 2 && book.locale === language);
    grade3Books = flpHomeBooks.filter(book => book.fluencyId === 3 && book.locale === language);

    const grade1GroupArray = [1,2,3,4,5].map(groupNumber => grade1Books.filter(book => parseInt(book.themeNumber , 10) === groupNumber))
    const grade2GroupArray = [1,2,3,4,5].map(groupNumber => grade2Books.filter(book => parseInt(book.themeNumber , 10) === groupNumber))
    const grade3GroupArray = [1,2,3,4,5].map(groupNumber => grade3Books.filter(book => parseInt(book.themeNumber , 10) === groupNumber))
    
    const isRtl = isRtlLanguage(language);

    return (
      <div className={classNames(gradesClasses)}>
        {
          grade1Books.length > 0 && grade1GroupArray.length > 0 && 
          <div >
            <div className={`${baseClassName}__title`}>{grade1Books[0].grade}</div>
            {
              grade1GroupArray.map((themeBooks, ind) => {
                return <OfflineGradeCard themeBooks={themeBooks} online={online} editActive={editActive} onChange={onChangeCheckedFlpValues}
                  themeCheckedValues={flpCheckedValues} fluencyId={1} viewport={viewport} isRtl={isRtl} open={ind === grade1GroupArray.findIndex(el => el.length>0)} />
              })
            }
          </div>
        }
        {
          grade2Books.length > 0 && grade2GroupArray.length > 0 && 
          <div >
            <div className={`${baseClassName}__title`}>{grade2Books[0].grade}</div>
            {
              grade2GroupArray.map((themeBooks, ind) => {
                return <OfflineGradeCard themeBooks={themeBooks} online={online} editActive={editActive} onChange={onChangeCheckedFlpValues}
                  themeCheckedValues={flpCheckedValues} fluencyId={2} viewport={viewport} isRtl={isRtl} open={grade1Books.length <= 0 && ind === grade2GroupArray.findIndex(el => el.length>0)}/>
              })
            }
          </div>
        }
        {
          grade3Books.length > 0 && grade3GroupArray.length > 0 && 
          <div >
            <div className={`${baseClassName}__title`}>{grade3Books[0].grade}</div>
            {
              grade3GroupArray.map((themeBooks, ind) => {
                return <OfflineGradeCard themeBooks={themeBooks} online={online} editActive={editActive} onChange={onChangeCheckedFlpValues}
                  themeCheckedValues={flpCheckedValues} fluencyId={3} viewport={viewport} isRtl={isRtl} open={(grade2Books.length <= 0 && grade1Books.length <= 0) && ind === grade3GroupArray.findIndex(el => el.length>0)}/>
              })
            }
          </div>
        }
      </div>
    )
  }

  renderStemHomeEl(baseClassName, language, gradesClasses) {
    const {t, stemHomeBooks, online, editActive, onChangeCheckedStemValues, stemCheckedValues, viewport, userId, userType} = this.props;
    let lpIds = []; 

    stemHomeBooks.forEach(el => {
      if(el.locale === language) {
        let existingLp = lpIds.find(e => e.lp === el.lpId)
        if (existingLp) {
          existingLp.books.push(el)     
        }
        else {
          lpIds.push({
            "lp" : el.lpId,
            "books" : [el]
          })
        }
      }
    })

    const isRtl = isRtlLanguage(language);
    
    return(
      <div className={classNames(gradesClasses)}>
        {
          lpIds.map((el, ind) => el.books.length > 0 && 
            <OfflineStemCard stemBooks={el.books} online={online} editActive={editActive} onChange={onChangeCheckedStemValues} t={t}  stemCheckedValues={stemCheckedValues} viewport={viewport} open={ind === 0} userId={userId} userType={userType} isRtl={isRtl}/>
            )
        }
      </div>
    )
  }

  renderHowToAdd(baseClassName) {
    const {
      t,
      rpLanguages,
      isRtl,
      activeTabIndex,
      onTriggerEvents,
      viewport
    } = this.props;

    let headerEl =  '';
    let addBtn = <Button 
      parentClassName={`${baseClassName}__header-btn`} 
      onClick={() => {onTriggerEvents({gtmAction: gaEventActions.addStories, gtmLabel: `${eventLabel}_tab`});window.location.href = href}} 
      label={activeTabIndex === 3 ? t('OfflineStemBooks.add-stem-topic') : t("OfflineBooks.add-stories")} 
      title={activeTabIndex === 3 ? t('OfflineStemBooks.add-stem-topic') : t("OfflineBooks.add-stories")} variant="primary" />
    let href = links.home();
    let eventLabel;
    if(activeTabIndex === 0 ) {
      eventLabel = gaEventLabel.read
      href =  links.allBooks()
      headerEl = <CollapsibleSection
          key="2"
          disableCollapse
          title={t("OfflineLibrary.signed.books-title")}
          theme="light"
          isRtl={isRtl}
        >
          {!viewport.medium && addBtn}
          <p className={`${baseClassName}__sub-title`}>{t("OfflineBooks.adding-to-offline-library-title")}</p>
          <ol id='offline'>
            <li>{t("OfflineBooks.adding-to-offline-step-1")}</li>
            <li>{t("OfflineBooks.adding-to-offline-step-2-pre-icon")}<SvgIcon name="offline" title={t('SvgTitle.offline')}/> {t("OfflineBooks.adding-to-offline-step-2-post-icon")}</li>
            <li>{t("OfflineBooks.adding-to-offline-step-3")}</li>
          </ol>
        </CollapsibleSection>
    }

    if(activeTabIndex === 1 ) {
      eventLabel = gaEventLabel.readingProgram
      href = links.rp(rpLanguages)
      headerEl = <CollapsibleSection
          key="2"
          disableCollapse
          title={t("OfflineLibrary.signed.rp-title")}
          theme="light"
          isRtl={isRtl}
        >
          {!viewport.medium && addBtn}
          <p className={`${baseClassName}__sub-title`}>{t("OfflineReadingBooks.adding-to-offline-library-title")}</p>
          <ol>
            <li>{t("OfflineReadingBooks.adding-to-offline-step-1")}</li>
            <li>{t("OfflineReadingBooks.adding-to-offline-step-2")} {"'"}<SvgIcon name="offline" title={t('SvgTitle.offline')}/>{"'"}</li>
            <li>{t("OfflineReadingBooks.adding-to-offline-step-3")}</li>
            <li>{t("OfflineReadingBooks.adding-to-offline-step-4")}</li>
          </ol>
        </CollapsibleSection>
    }

    if(activeTabIndex === 2) {
      eventLabel = gaEventCategories.flpMerge
      href = links.flpHomeGrades(rpLanguages, 1)
      headerEl = <CollapsibleSection
          key="3"
          disableCollapse
          title={t("OfflineLibrary.signed.flp-title")}
          theme="light"
          isRtl={isRtl}
        >
          {!viewport.medium && addBtn}
          <p className={`${baseClassName}__sub-title`}>{t("OfflineFlpBooks.adding-to-offline-library-title")}</p>
          <ol>
            <li>{t("OfflineFlpBooks.adding-to-offline-step-1")}</li>
            <li>{t("OfflineFlpBooks.adding-to-offline-step-2")} {"'"}<SvgIcon name="offline" title={t('SvgTitle.offline')}/>{"'"}</li>
            <li>{t("OfflineFlpBooks.adding-to-offline-step-3")}</li>
          </ol>
        </CollapsibleSection>
    }

    if(activeTabIndex === 3) {
      eventLabel = gaEventCategories.stem
      href = links.stemHome(rpLanguages)
      headerEl = <CollapsibleSection
          key="4"
          disableCollapse
          title={t("OfflineLibrary.signed.stem-title")}
          theme="light"
          isRtl={isRtl}
        >
          {!viewport.medium && addBtn}
          <p className={`${baseClassName}__sub-title`}>{t("OfflineStemBooks.adding-to-offline-library-title")}</p>
          <ol>
            <li>{t("OfflineStemBooks.adding-to-offline-step-1")}</li>
            <li>{t("OfflineStemBooks.adding-to-offline-step-2")} {"'"}<SvgIcon name="offline" title={t('SvgTitle.offline')}/>{"'"}</li>
            <li>{t("OfflineStemBooks.adding-to-offline-step-3")}</li>
          </ol>
        </CollapsibleSection>
    }

    if(activeTabIndex === 4) {
      eventLabel = gaEventLabel.translate
      href =  links.translate()
      headerEl = <CollapsibleSection
          key="2"
          disableCollapse
          title={t("OfflineLibrary.signed.translate-title")}
          theme="light"
          isRtl={isRtl}
        >
          {!viewport.medium && addBtn}
          <p className={`${baseClassName}__sub-title`}>{t("OfflineTranslate.adding-to-offline-library-title")}</p>
          <ol>
            <li>{t("OfflineTranslate.adding-to-offline-step-1")}</li>
            <li>{t("OfflineTranslate.adding-to-offline-step-2-pre-icon")}<SvgIcon name="offline" title={t('SvgTitle.offline')}/>{t('OfflineTranslate.adding-to-offline-step-2-post-icon')}</li>
            <li>{t("OfflineTranslate.adding-to-offline-step-3")}</li>
            <li>{t("OfflineTranslate.adding-to-offline-step-4")}</li>
            <li>{t("OfflineTranslate.adding-to-offline-step-5")}</li>
          </ol>
          <br/>
          <span>{t('global.note')}!</span>
          <ul className={`${baseClassName}__translate-notes`}>
            <li>
              <span>{t("OfflineTranslate.note-1")}</span>
            </li>
            <li>
              <span>{t("OfflineTranslate.note-2")}</span>
            </li>
          </ul>
        </CollapsibleSection>
    }

    return(
      <div className={isRtl ? `${baseClassName}__header-section ${baseClassName}__header-section--rtl` : `${baseClassName}__header-section`}>
        {headerEl}
        {viewport.medium && <Button parentClassName={`${baseClassName}__header-btn`} onClick={() => {onTriggerEvents({gtmAction: gaEventActions.addStories, gtmLabel: `${eventLabel}_tab`});window.location.href = href}} label={activeTabIndex === 3 ? t('OfflineStemBooks.add-stem-topic') : t("OfflineBooks.add-stories")} title={activeTabIndex === 3 ? t('OfflineStemBooks.add-stem-topic') : t("OfflineBooks.add-stories")} variant="primary" fullWidth />}
      </div>
    )
  }

  renderEditToolbar(baseClassName) {
    const {
      t,
      editActive,
      viewport,
      onCancel,
      isSomethingSelected,
      activeTabIndex,
      isRtl
    } = this.props;

    const editClasses = {
      [`${baseClassName}__edit-container`]: true,
      [`${baseClassName}__edit-container--rtl`]: isRtl,
      [`${baseClassName}__legend`]: !viewport.medium
    }

    let legendEl = ''
    if(activeTabIndex === 0 ) {
      legendEl = t("OfflineBooks.edit-legend")
    } 
    if(activeTabIndex === 1 ) {
      legendEl = t("OfflineBooks.edit-rp-tab-legend")
    }
    if(activeTabIndex === 2) {
      legendEl = t("OfflineBooks.edit-flp-tab-legend")
    }
    if(activeTabIndex === 3) {
      legendEl = t("OfflineBooks.edit-stem-tab-legend")
    }
    if(activeTabIndex === 4) {
      legendEl = t("OfflineBooks.translate-edit-legend")
    }
    if (editActive) {
      return (
          <div className={classNames(editClasses)}>
            <p className={`${baseClassName}__edit-legendEl`}>{legendEl}</p>
            <div className={`${baseClassName}__edit-actions`}>
              <Button
                iconLeft="bin-new"
                label={t("OfflineBooks.delete")}
                onClick={activeTabIndex === 3 ? this.props.onStemTabDelete : activeTabIndex === 2 ? this.props.onFlpTabDelete : activeTabIndex === 1 ? this.props.onReadingTabDelete : this.props.onDelete}
                parentClassName={`${baseClassName}__offline-delete-btn`}
                variant={'offline-active'}
                disabled={!isSomethingSelected}
                isRtl={isRtl}
              />
              <Button
                parentClassName={`${baseClassName}__offline-delete-btn`}
                label={t("OfflineBooks.cancel")}
                onClick={onCancel}
                variant={'offline'}
                isRtl={isRtl}
              />
            </div>
          </div>
      );
    }
  }

  render() {
    const baseClassName = 'pb-offline-books';

    const {
      t,
      // books,
      editActive,
      onChangeCheckedValues,
      onChangeCheckedTranslateValues,
      online,
      viewport,
      activeTabIndex,
      isRtl,
      readBooks,
      offlineTranslateBooks,
      filtersComponent,
      flpHomeFiltersComponent,
      stemHomeFiltersComponent,
      rpLanguages,
      openAuthModal,
      isLoggedIn,
      isFetchingMe,
      rpLanguageSelectedBooks,
      flpHomeBooks,
      stemHomeBooks
    } = this.props;

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--offline`]: !online,
    }

    let storiesCount = 0;

    if(activeTabIndex === 0) {
      storiesCount = readBooks;
    } 
    if( activeTabIndex === 1 ) {
      storiesCount = rpLanguageSelectedBooks && rpLanguageSelectedBooks.filter(el=> el.locale === rpLanguages)
    }
    if( activeTabIndex === 2) {
      storiesCount = flpHomeBooks && flpHomeBooks.filter(el=> el.locale === rpLanguages)
    }
    if( activeTabIndex === 3) {
      storiesCount = stemHomeBooks && stemHomeBooks.filter(el=> el.locale === rpLanguages)
    }
    if( activeTabIndex === 4) {
      storiesCount = offlineTranslateBooks;
    }

    const gradesClasses = {
      [ `${baseClassName}__grades-wrapper`]: storiesCount && storiesCount.length > 0
    }

    const tabContentEl = (bookList, url, tabName) => {
      return(
      editActive
      ?
      <div className={`${baseClassName}--offline__grid`}>
      <SelectableGrid
        id="offline-book-selectable-grid"
        variant="2up-6up"
        activeIcon={"active"}
        inactiveIcon={"inactive"}
        roundedCorners
        onChange={onChangeCheckedValues}
        alignRight
        onTranslateTabChange={onChangeCheckedTranslateValues}
        theme="danger">
        {this.renderBookEls(bookList, tabName)}
      </SelectableGrid>
      </div>
      :
      <div className={`${baseClassName}--offline__grid`}>
        <Grid variant="2up-6up">
          {this.renderBookEls(bookList, tabName)}
        </Grid>
      </div>
      )
    };

    const offlineUnsignedData = (<div className={isRtl ? `${baseClassName}__offline-unsigned ${baseClassName}__offline-unsigned--rtl` :`${baseClassName}__offline-unsigned`}>
      <div className={`${baseClassName}__offline-unsigned--header`}>
        <span>{t('OfflineLibrary.header')}
        <SvgIcon name="offline-icon" title={t('SvgTitle.offline')} pushLeft={!isRtl} pushRight={isRtl} /></span>
      </div>
      <ul className={`${baseClassName}__offline-unsigned--list`}>
        <li>{t('OfflineLibrary.unsigned.access-1')}</li>
        <li>{t('OfflineLibrary.unsigned.access-2')}</li>
        <li>{t('OfflineLibrary.unsigned.access-3')}</li>
        <li>{t('OfflineLibrary.unsigned.access-4')}</li>
        <li>{t('OfflineLibrary.unsigned.access-5')}</li>
      </ul>
      <p className={`${baseClassName}__offline-unsigned--list ${baseClassName}__offline-unsigned--text`}> {t('OfflineLibrary.unsigned.sub-text')}</p>
      <Button
        label={t('OfflineBooks.login')}
        variant="primary"
        parentClassName={`${baseClassName}__offline-unsigned--btn`}
        onClick={()=>openAuthModal()}
        disabled={!online}
      />
    </div>)

    const leftItem = <div className={`${baseClassName}__header-logo`}>
      <SvgIcon name="offline-icon" pushLeft={isRtl} pushRight={!isRtl}/>
      <p className={`${baseClassName}__header-logo--title`}><span>{t('OfflineLibrary.story-weaver')}</span><br /> {t('global.offline-library')}</p>
    </div>

    const rightItem = <div className={`${baseClassName}__right-item`}>
      <span onClick={() => this.onOpenModal('help')}><SvgIcon name="info-offline" parentClassName={`${baseClassName}__information`}/></span>
      {viewport.medium ?
        <Button
          iconLeft="bin-new"
          label={t("OfflineBooks.delete")}
          onClick={() => this.props.onManage()}
          variant={'offline-active'}
          section="offline"
          viewport={viewport}
          isRtl={isRtl}
          fullWidth
          disabled={(!editActive && (storiesCount && storiesCount.length > 0)) ? false : true}
        />
        :
        <span className={!editActive && storiesCount && storiesCount.length > 0 ? `${baseClassName}__bin-icon--active` : `${baseClassName}__bin-icon`} onClick={() => !editActive && storiesCount && storiesCount.length > 0 ? this.props.onManage() : null}><SvgIcon name="bin-new" /></span>
      }
      </div>

    const tabsData = (<Tabs
      onTabChange={this.onTabChange}
      variant="offline-tabs"
      activeTabIndex={activeTabIndex}
      setIndex={activeTabIndex}
      isRtl={isRtl}
      leftTab={viewport.medium && leftItem}
      rightTab={viewport.medium && rightItem}
      offlineTabs
    >

      <Tab
        shouldUnloadContent={false}
        title={`${t("global.book", 2)}`}
        count={readBooks && readBooks.length }
      >
        {this.renderEditToolbar(baseClassName)}
        {readBooks.length > 0 && tabContentEl(readBooks, links.allBooks(), 'books')}
        {online && !editActive && this.renderHowToAdd(baseClassName)}
      </Tab>

      <Tab
        shouldUnloadContent={false}
        title={`${t("OfflineBooks.reading-programme")}`}
        count={rpLanguageSelectedBooks && rpLanguageSelectedBooks.length }
      >
        <div>
          {filtersComponent}
          {this.renderEditToolbar(baseClassName)}
          {this.renderReadingProgramThemeEl(baseClassName, rpLanguages, gradesClasses)}
          {online && !editActive && this.renderHowToAdd(baseClassName)}
        </div>
      </Tab>

      <Tab
        shouldUnloadContent={false}
        title={t('global.flp-home')}
        count={flpHomeBooks && flpHomeBooks.length }
      >
        {flpHomeFiltersComponent}
        {this.renderEditToolbar(baseClassName)}
        {this.renderFlpHomeEl(baseClassName, rpLanguages, gradesClasses)}
        {online && !editActive && this.renderHowToAdd(baseClassName)}
      </Tab>

      <Tab
        shouldUnloadContent={false}
        title={t('global.stem')}
        count={stemHomeBooks && stemHomeBooks.length }
      >
        {stemHomeFiltersComponent}
        {this.renderEditToolbar(baseClassName)}
        {this.renderStemHomeEl(baseClassName, rpLanguages, gradesClasses)}
        {online && !editActive && this.renderHowToAdd(baseClassName)}
      </Tab>

      <Tab
        shouldUnloadContent={false}
        hidden={!viewport.medium}
        title={`${t("OfflineBooks.translate")}`}
        count={offlineTranslateBooks && offlineTranslateBooks.length }
      >
        {this.renderEditToolbar(baseClassName)}
        {viewport.medium && offlineTranslateBooks.length > 0 && tabContentEl(offlineTranslateBooks, links.translate(), 'translate')}
        {online && !editActive && this.renderHowToAdd(baseClassName)}
      </Tab>
    </Tabs>)

    return (
      <div className={classNames(classes)}>
        <DocumentClass className={`${baseClassName}-document`} />
        <Helmet>
          <title>{`${t('global.offline-library')} - ${t('global.site-title')}`}</title>
        </Helmet>
        {isFetchingMe ?
        <LoaderBlock size="offline"/>
        :
        (
          isLoggedIn || (!online && localStorage.getItem('userName')) ?  
          <div className={`${baseClassName}__offline-signed`}>
            {!viewport.medium && <div className={isRtl ? `${baseClassName}__logo-section--mob ${baseClassName}__logo-section--mob-rtl` :`${baseClassName}__logo-section--mob`}>
              {leftItem}
              {rightItem}
            </div>}
            {tabsData}
          </div>
          :
          offlineUnsignedData
        )}

        {
          this.state.isModalVisible.help
            ?
            <Modal onClose={() => this.onCloseModal('help')} parentClassName={`${baseClassName}__help-modal`} isRtl={isRtl}>
              <div className={`${baseClassName}__help-modal--wrapper`}>
                <SvgIcon name="offline-icon" title={t('SvgTitle.offline')} />
                <p className={`${baseClassName}__help-modal--title`}>{t("OfflineLibrary.header")}</p>
                <p className={`${baseClassName}__help-modal--desc`}>{t("OfflineLibrary.information.text")}</p>
                <ul className={`${baseClassName}__help-modal--desc ${baseClassName}__help-modal--list`}>
                  <li>{t("OfflineLibrary.information.step-1")}</li>
                  <li>{t("OfflineLibrary.information.step-2")}</li>
                  <li>{t("OfflineLibrary.information.step-3")}</li>
                  {siteLocale !== "en" && <li>{t("OfflineLibrary.information.step-4")}</li>}
                </ul>
              </div>
            </Modal>
            :
            null
        }
      </div>
    );
  }
}

OfflineBooks.propTypes = {
  viewport: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  books: PropTypes.arrayOf(PropTypes.shape(BookCard.propTypes)).isRequired,
  editActive: PropTypes.bool,
  onDelete: PropTypes.func,
  onCancel: PropTypes.func,
  onManage: PropTypes.func,
  online: PropTypes.bool,
  isSomethingSelected: PropTypes.bool
};

export default OfflineBooks;



// WEBPACK FOOTER //
// ./src/components/OfflineBooks/OfflineBooks.jsx